import EventEmitter from "./utils/EventEmitter";

export default class Tooltip extends EventEmitter {
    constructor() {
        super();

        // we need to create a tooltip for each element with the data attribute data-definition
        this.elements = document.querySelectorAll('[data-definition]')


        this.createTooltip()
        this.events()
    }

    createTooltip() {
        // create tooltip, a div with the class tooltip
        this.tooltip = document.createElement('div')
        this.tooltip.classList.add('tooltip')
        // add a dive with class triangle
        this.triangle = document.createElement('div')
        this.triangle.classList.add('triangle')
        // add a div with class tooltip-content
        const content = document.createElement('div')
        content.classList.add('tooltip-content')
        // append triangle and content to the tooltip
        this.tooltip.appendChild(this.triangle)
        this.tooltip.appendChild(content)
        // append tooltip to the body
        document.body.appendChild(this.tooltip)
    }

    events() {
        this.elements.forEach((el) => {
            // each time we hover on an element, we need to update the tooltip content and position
            el.addEventListener('mouseover', () => {
                this.updateTooltip(el)
                this.positionTooltip(el)
            })

            // when we leave the element, we need to hide the tooltip
            el.addEventListener('mouseleave', () => {
                this.hideTooltip()
            })
        })
    }

    updateTooltip(el) {
        // update tooltip content
        this.tooltip.querySelector('.tooltip-content').innerHTML = el.dataset.definition
    }

    positionTooltip(el) {
        const rect = el.getBoundingClientRect()

        // position the bottom of the tooltip on top of the element
        this.tooltip.style.top = `${el.getBoundingClientRect().top - this.tooltip.getBoundingClientRect().height - 20}px`
        // position the left of the tooltip on the left of the element but centered it on the element
        this.tooltip.style.left = `${rect.left + (rect.width / 2) - (this.tooltip.getBoundingClientRect().width / 2)}px`

        // The triangle is positioned in fixed so we need to calculate the position of the triangle to be centered on the element
        this.triangle.style.left = `${rect.left + rect.width / 2 - 10}px`
        this.triangle.style.top = `${el.getBoundingClientRect().top - 20}px`

        // Adjust the tooltip position if it's outside the viewport
        if (this.tooltip.getBoundingClientRect().left < 0) {
            this.tooltip.style.left = `${rect.left}px`
        }

        this.tooltip.classList.add('is-visible')
    }

    hideTooltip() {
        // hide the tooltip
        this.tooltip.classList.remove('is-visible')
    }


}
